<template>
  <div v-if="canShow" class="user-list">
    <b-table
      v-if="!state.$busy && users.length"
      :fields="fields"
      :items="users"
      responsive="sm"
    >
      <!--       <template #cell(permissions)="data">
        <user-permission-form :site="site" :user="data.item" @updating="reset" @updated="onUpdate"/>
      </template> -->
      <template #cell(actions)="data">
        <user-removal-form
          :site="site"
          :user="data.item"
          @removing="reset"
          @removed="onRemove"
        />
      </template>
      <template #cell()="data">
        {{ data.value }}
      </template>
    </b-table>
    <div v-else-if="!state.$busy && !users.length">
      <h6>No users assigned to the site yet</h6>
    </div>
    <b-table v-else :fields="fields" :items="shimmerItems" responsive="sm">
      <template #cell()="data">
        <shimmer width="100%" height="16px" />
      </template>
    </b-table>

    <b-pagination
      v-if="hasPagination && users.length"
      v-model="currentPage"
      :limit="limit"
      :per-page="perPage"
      :total-rows="totalPage"
      :disabled="state.$busy"
      :hide-goto-end-buttons="true"
      :hide-goto-start-buttons="true"
      class="d-flex justify-content-center"
      @change="fetch"
    />

    <b-alert class="custom-alert" variant="primary" fade :show="showAlert">
      <b-container class="mt-3">
        <div class="d-flex justify-content-between">
          <div>{{ alertMessage }}</div>
          <div>
            <div class="c-pointer" @click.prevent="showAlert = false">
              <u>Close</u>
            </div>
          </div>
        </div>
      </b-container>
    </b-alert>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Form from '@/utils/form'
import Site from '@/models/Site'
// import UserPermissionForm from '@/components/forms/site/UserPermissionForm'
import UserRemovalForm from '@/components/forms/site/UserRemovalForm'
import shimmer from '@/components/shimmers/shimmer'

export default {
  components: {
    // UserPermissionForm,
    UserRemovalForm,
    shimmer
  },

  props: {
    site: {
      type: [Site, Object],
      default: null
    },

    limit: {
      type: Number,
      default: 8
    },

    autoFetch: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      currentPage: 1,
      perPage: 0,
      totalPage: 0,

      visibility: false,
      state: new Form({}),
      fields: [
        'full_name',
        { key: 'roleText', label: 'Role', class: 'role-cell' },
        'email',
        // 'Permissions',
        { key: 'actions', label: 'Action(s)', class: 'action-cell text-center' }
      ],

      showAlert: false,
      alertMessage: ''
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      users: state => state.user.list,
      usersMeta: state => state.user.listMeta
    }),

    shimmerItems() {
      return [...Array(this.limit).keys()]
    },

    hasPagination() {
      return this.usersMeta && this.usersMeta.last_page > 1
    },

    canShow() {
      return (
        this.site && this.user && (this.user.is_admin || this.site.canViewUser)
      )
    }
  },

  watch: {
    usersMeta(value) {
      if (value) {
        this.currentPage = value.current_page
        this.perPage = value.per_page
        this.totalPage = value.total
      }
    }
  },

  methods: {
    ...mapActions({
      getUsers: 'user/getUsers'
    }),
    ...mapMutations({
      clearUsers: 'user/clearUserList'
    }),

    reset() {
      this.showAlertMessage(null, false)
    },

    async fetch(page = 1) {
      if (this.state.$busy) return

      this.state.$setLoading(true)
      this.clearUsers()

      this.currentPage = page

      await this.getUsers({
        page: this.currentPage,
        limit: this.limit,
        site: this.site ? this.site.site_id : null
      })
        .catch(error => {
          this.state.$handleError(error)
          this.showAlertMessage(this.state.$errorMessage)
        })
        .finally(() => {
          this.state.$setLoading(false)
        })
    },

    // onUpdate(data) {
    //   this.showAlertMessage(data)
    //   this.fetch()
    // },

    onRemove(data) {
      this.showAlertMessage(data)
      this.fetch()
    },

    showAlertMessage(msg, show = true) {
      this.showAlert = show
      this.alertMessage = msg
    }
  },

  created() {
    if (this.autoFetch) {
      this.fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.user-list /deep/ {
  width: 100%;

  .table {
    thead {
      th {
        border-top: none;
      }
    }

    tbody {
      .role-cell {
        text-transform: capitalize;
      }

      .action-cell {
        width: 200px;
      }
    }
  }
}

.custom-alert {
  height: 80px;
  align: center;
  text-align: left;
}
</style>
